import { SECTION_IDS } from '@/utils'

/**
 * Hero section content
 */
export const heroContent = {
  headline: 'Websites That Help Plumbing Companies Get More Calls',
  subheadline: 'Fast, modern, mobile-friendly websites designed to generate leads and grow your plumbing business. Built specifically for service contractors who want real results.',
  primaryCTA: {
    text: 'Get a Free Consultation',
    link: `#${SECTION_IDS.CONTACT}`,
  },
  secondaryCTA: {
    text: 'View Pricing',
    link: `#${SECTION_IDS.PRICING}`,
  },
  valuePoints: [
    'Built for Small Businesses',
    'Designed to Generate Leads',
    'Mobile-First & Fast Loading',
    'Local SEO Ready',
  ],
}

/**
 * Trust section content
 */
export const trustContent = {
  heading: 'Why Choose Leru Systems',
  cards: [
    {
      title: 'Built for Small Businesses',
      description: 'We understand the challenges small plumbing companies face. Our websites are affordable, practical, and designed to deliver ROI.',
    },
    {
      title: 'Designed to Generate Leads',
      description: 'Every element is strategically placed to convert visitors into customers—clear CTAs, contact forms, and trust signals.',
    },
    {
      title: 'Mobile-First & Fast',
      description: 'Most customers search on mobile. Our sites are optimized for mobile devices and load blazingly fast.',
    },
    {
      title: 'Local SEO Ready',
      description: 'Get found by customers in your area with built-in local SEO best practices and Google Business integration.',
    },
  ],
}

/**
 * Problem section content
 */
export const problemContent = {
  heading: 'Is Your Website Costing You Plumbing Jobs?',
  subheading: 'Many plumbing companies lose potential customers because of these common website problems:',
  painPoints: [
    {
      title: 'Outdated Design',
      description: 'An old-looking website makes your business look unprofessional and outdated.',
    },
    {
      title: 'Poor Mobile Experience',
      description: "If your site doesn't work well on phones, you're losing the majority of your potential customers.",
    },
    {
      title: 'Not Ranking in Search',
      description: "Without proper SEO, customers can't find you when they search for plumbers in your area.",
    },
    {
      title: "Visitors Don't Convert",
      description: 'Traffic without conversions means wasted opportunities. Your site needs clear calls-to-action.',
    },
    {
      title: 'Weak Online Credibility',
      description: 'No testimonials, outdated photos, or missing information makes potential customers doubt your reliability.',
    },
  ],
}

/**
 * Why Leru section content
 */
export const whyLeruContent = {
  heading: 'Why Work With Leru Systems',
  differentiators: [
    {
      title: 'Results-Focused Approach',
      description: 'We measure success by the leads and customers your website generates, not just how it looks.',
    },
    {
      title: 'Specialized for Service Businesses',
      description: 'We focus exclusively on websites for service contractors like plumbers, HVAC, and electricians.',
    },
    {
      title: 'Affordable for Small Companies',
      description: 'Fair, transparent pricing designed for small businesses. No hidden fees or surprise charges.',
    },
    {
      title: 'Easy to Work With',
      description: 'Clear communication, no technical jargon, and a streamlined process that respects your time.',
    },
    {
      title: 'Technical Expertise',
      description: 'Our team combines design talent with technical skills to build fast, secure, and effective websites.',
    },
  ],
}

/**
 * Final CTA section content
 */
export const finalCTAContent = {
  heading: 'Ready to Get More Plumbing Customers?',
  subheading: "Let's build a website that grows your business",
  cta: {
    text: 'Schedule Free Consultation',
    link: `#${SECTION_IDS.CONTACT}`,
  },
  note: 'No obligation. No pressure. Just results.',
}
